import { createComponent } from '@carvana/merch-components';
import { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const SearchIcon = createComponent<OwnProps>('svg', {
  className: '-:text-grey-5'
});

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <SearchIcon
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0.000366211C3.13401 0.000366211 0 3.13437 0 7.00037C0 10.8664 3.13401 14.0004 7 14.0004C8.57234 14.0004 10.0236 13.482 11.1922 12.6068L14.2929 15.7075C14.6834 16.098 15.3166 16.098 15.7071 15.7075C16.0976 15.3169 16.0976 14.6838 15.7071 14.2933L12.6064 11.1925C13.4816 10.024 14 8.5727 14 7.00037C14 3.13437 10.866 0.000366211 7 0.000366211ZM2 7.00037C2 4.23894 4.23858 2.00037 7 2.00037C9.76142 2.00037 12 4.23894 12 7.00037C12 9.76179 9.76142 12.0004 7 12.0004C4.23858 12.0004 2 9.76179 2 7.00037Z"
      fill="#6D7184"
    />
  </SearchIcon>
));
